import React from 'react';
import Text from 'ui/Text';
import infoIcon from 'images/icons/big9/exclamation_mark.svg';

const LoginWarning = ({ loggedIn }) => {
    return (
        <div
            className={
                loggedIn ? 'sk-not-logged-in ' : 'sk-not-logged-in sk-logged-in'
            }
        >
            <img src={infoIcon} alt={'infoIcon'} />
            {loggedIn ? (
                <div>
                    <Text condensed size="14" color="#333" padding={'0'} bold>
                        Her er desværre tomt
                    </Text>
                    <Text
                        condensed
                        size="x1"
                        color="#333"
                        padding={'0'}
                        margin={'5px 0 0'}
                    >
                        Fremover vil du finde de SpilKlubber du enten selv
                        opretter eller køber andel(e) i her.
                    </Text>
                </div>
            ) : (
                <Text
                    condensed
                    size="x1"
                    color="#333"
                    padding={'0'}
                    margin={'0'}
                    align={'center'}
                >
                    Du skal logge ind for at se dine klubber.
                </Text>
            )}
        </div>
    );
};

export default LoginWarning;
